<template>
<v-card max-height="759px">
  <v-container style="padding: 32px 40px;">
    <v-row>
      <v-col cols="11">
        <h4 style="font-weight:bold;">ブックマークファイルアップロード</h4>
      </v-col>
      <v-col cols="1">
        <IconButton iconStr="mdi-close" :event="modalClose" />
      </v-col>
    </v-row>
    <v-row style="40px">
      <v-alert
        dense
        outlined
        type="error"
        v-model="alert"
      >ブックマークファイルが対応していません。
      </v-alert>
    </v-row>
    <v-row>
      <v-col cols="12">
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <ValidationProvider rules="required" name="ブックマーク">
          <label style="font-size: 14px;" for="file">
            ※Chrome、Safari、はてなブックマーク、Pocketでエクスポートしたファイルに対応しております
          </label>
          <v-file-input
            outlined
            label="ブックマークファイル"
            accept=".html"
            filled
            prepend-icon=''
            v-model="bookmark"
            id='file'
          ></v-file-input>
        </ValidationProvider>
        <p @click="clickHelp()" style="text-align:end; color:#5E00BC; font-size:12px; margin: -12px 0 40px; 0">
          <v-icon small color="primary" style="margin-bottom: 2px;">mdi-information</v-icon>
          <span style="text-decoration:underline; text-decoration-color:#5E00BC;">ブックマークファイルエクスポート方法</span>
        </p>
        <BookmarkHelpModal v-if="isHelp" />
        <v-divider></v-divider>
        <br/>
        <v-row>
          <v-col cols="7">
          </v-col>
          <v-col cols="5">
            <EventButton
              buttonName="アップロード" :event="submit"
              :isDisabled="invalid" :isLoading="isUploadButtonLoading"
              style="font-size: 16px; padding: 9px 62px; margin-left: 14px;"
            />
          </v-col>
        </v-row>
      </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</v-card>
</template>
<script>
import EventButton from '../atoms/EventButton.vue';
import BookmarkHelpModal from '../organisms/BookmarkHelpModal.vue';
import IconButton from '../atoms/IconButton.vue';
export default {
  data() {
    return {
      loading: false,
      bookmark: [],
      bookmarkList: '',
      isUploadButtonLoading: false,
      alert: false,
      isHelp: false,
    };
  },
  name: 'BookmarkUploadModal',
  props: ['isCloseBookmarkModal', 'changeModalState'], 
  components: {
    EventButton,
    BookmarkHelpModal,
    IconButton
  },
  methods: {
    async submit() {
      this.isUploadButtonLoading = true;
      this.alert = false;
      let formData = new FormData();
      formData.append('bookmark', this.bookmark);
      await this.$store.dispatch('bookmark/get', formData)
        .then(() => {
          this.bookmarkList = this.$store.getters['bookmark/bookmarkList'];
          this.changeModalState(1);
        })
        .catch((error) => {
          console.log('error');
          if (error.response.status === 428) {
            this.alert = true;
          }
        })
        .finally(() => {
          this.isUploadButtonLoading = false;
        })
    },
    clickHelp() {
      this.isHelp = !this.isHelp;
    },
    modalClose() {
      this.stateReset();
      this.isCloseBookmarkModal();
    },
    stateReset() {
      this.loading = false;
      this.bookmark = [];
      this.bookmarkList = '';
      this.isUploadButtonLoading = false;
      this.alert = false;
      this.isHelp = false;
    }
	},
}
</script>
<style scoped>
</style>